module.exports = __webpack_public_path__ + "img/azul.e43c215d.png";